var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Spinner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Outline",
    d: "M35.8752 20.0002C35.8752 23.1399 34.9441 26.2092 33.1997 28.8198C31.4554 31.4305 28.976 33.4652 26.0753 34.6667C23.1745 35.8683 19.9826 36.1827 16.9031 35.5701C13.8237 34.9576 10.995 33.4456 8.77484 31.2255C6.55468 29.0053 5.04274 26.1767 4.4302 23.0972C3.81766 20.0178 4.13203 16.8258 5.33358 13.9251C6.53512 11.0243 8.56985 8.54495 11.1805 6.80058C13.7911 5.05622 16.8604 4.12516 20.0002 4.12516",
    stroke: "#DDE2E4",
    strokeWidth: 1.58333
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.d1c52c82d867422a4cfedbb16ef1ba21.svg";
export { ForwardRef as ReactComponent };